import {all, call, fork, put, takeLatest} from "redux-saga/effects";
import * as actions from "../actions/actions";
import {
    downloadCorporateTemplate,
    downloadGeneralReportApi,
    downloadGeneralReportDetailsApi,
    fileStatsRequest,
    generalReportApi,
    getFilesByCampaign,
    plickBankStats,
    plickStatusType
} from "../../api/fileApi";
import {getCorporatesByBankId} from "../../api/corporateApi";
import {getCampaignsByCorporate} from "../../api/campaignApi";

export default function* ReportSaga() {
    yield all([
        fork(watchGeneralReportBankIdChange),
        fork(watchGeneralReportCorporateIdChange),
        fork(watchGeneralReportCampaignIdChange),
        fork(watchGeneralReportFileIdChange),
        fork(watchGeneralReportDateStartChange),
        fork(watchGeneralReportDateEndChange),
        fork(watchGeneralReportWhatsappChange),
        fork(watchGeneralReportSmsChange),
        fork(watchGeneralReportEmailChange),
        fork(watchGeneralReportOrdinaryChange),
        fork(watchGeneralReportFutureDateChange),
        fork(watchGeneralReportStatusChange),
        fork(watchFileStatsBankChange),
        fork(watchFileStatsCorporateChange),
        fork(watchGetFileStats),
        fork(watchGetGeneralReportRequest),
        fork(watchGetPlickStatusTypeRequest),
        fork(watchPlickstatsBankIdChange),
        fork(watchGetPlickStats),
        fork(watchFetchCorporate),
        fork(watchFetchCampaign),
        fork(watchFetchFiles),
        fork(watchDownloadGeneralReportRequest),
        fork(watchDownloadGeneralReportDetailsRequest),
        fork(watchDownloadTemplateRequest),
    ]);
}

function* watchGetGeneralReportRequest() {
    yield takeLatest(
        actions.FETCH_REPORT_GENERAL_REQUEST,
        getGeneralReportRequest
    )
}

function* getGeneralReportRequest(generalReport) {
    yield put({type: actions.CLEAN_ERROR})
    yield put({ type: actions.PROGRESS_START_REQUEST })
    try {
        let { data } = yield call(generalReportApi, generalReport.value)
        yield put({ type: actions.FETCH_REPORT_GENERAL_SUCCESS, value: data })
        // yield put(push(`/user`))
        yield put({ type: actions.PROGRESS_STOP_REQUEST })
    } catch (error) {
        if(error.response){
            yield put({ type: actions.FETCH_REPORT_GENERAL_FAILURE, error: error.response })
            yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
            yield put({ type: actions.PROGRESS_STOP_REQUEST })
        }else if(error.request)
        {
            yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error })
            yield put({ type: actions.PROGRESS_STOP_REQUEST })
        }
    }
}

function* watchDownloadGeneralReportRequest() {
    yield takeLatest(
        actions.FETCH_REPORT_GENERAL_DOWNLOAD_REQUEST,
        downloadGeneralReportRequest
    )
}

function* downloadGeneralReportRequest(generalReport) {
    yield put({type: actions.CLEAN_ERROR})
    try {
        let { data } = yield call(downloadGeneralReportApi, generalReport.value)
        
    } catch (error) {
        if(error.response){
            yield put({ type: actions.FETCH_REPORT_GENERAL_DOWNLOAD_FAILURE, error: error.response })
            yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
        }else if(error.request)
        {
            yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error })
        }
    }
}


function* watchDownloadGeneralReportDetailsRequest() {
    yield takeLatest(
        actions.FETCH_REPORT_GENERAL_DETAILS_DOWNLOAD_REQUEST,
        downloadGeneralReportDetailsRequest
    )
}

function* downloadGeneralReportDetailsRequest(generalReport) {
    yield put({type: actions.CLEAN_ERROR})
    try {
        let { data } = yield call(downloadGeneralReportDetailsApi, generalReport.value)
        
    } catch (error) {
        if(error.response){
            yield put({ type: actions.FETCH_REPORT_GENERAL_DETAILS_DOWNLOAD_FAILURE, error: error.response })
            yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
        }else if(error.request)
        {
            yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error })
        
        }
    }
}

function* watchDownloadTemplateRequest() {
    yield takeLatest(
        actions.DOWNLOAD_CORPORATE_TEMPLATE_REQUEST,
        downloadTemplateRequest
    )
}

function* downloadTemplateRequest() {
    yield put({type: actions.CLEAN_ERROR})
    yield put({ type: actions.PROGRESS_START_REQUEST })
    try {
        let { data } = yield call(downloadCorporateTemplate)
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Corporate Portal Template 1.0.xlsx');
        document.body.appendChild(link);
        link.click();

        // yield put({ type: actions.FETCH_REPORT_GENERAL_DOWNLOAD_SUCCESS, value: data })
        // yield put(push(`/user`))
        yield put({ type: actions.PROGRESS_STOP_REQUEST })
    } catch (error) {
        if(error.response){
            yield put({ type: actions.DOWNLOAD_CORPORATE_TEMPLATE_FAILURE, error: error.response })
            yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
            yield put({ type: actions.PROGRESS_STOP_REQUEST })
        }else if(error.request)
        {
            yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error })
            yield put({ type: actions.PROGRESS_STOP_REQUEST })
        }
    }
}


function* watchGetFileStats() {
    yield takeLatest(
        actions.FETCH_REPORT_CORPORATE_FILE_STATS_REQUEST,
        getFileStats
    )
}

function* getFileStats(fileStats) {
    yield put({type: actions.CLEAN_ERROR})
    yield put({ type: actions.PROGRESS_START_REQUEST })
    try {
        let { data } = yield call(fileStatsRequest, fileStats.value)
        yield put({ type: actions.FETCH_REPORT_CORPORATE_FILE_STATS_SUCCESS, value: data })
        // yield put(push(`/user`))
        yield put({ type: actions.PROGRESS_STOP_REQUEST })
    } catch (error) {
        if(error.response){
            yield put({ type: actions.FETCH_REPORT_CORPORATE_FILE_STATS_FAILURE, error: error.response })
            yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
            yield put({ type: actions.PROGRESS_STOP_REQUEST })
        }else if(error.request)
        {
            yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error })
            yield put({ type: actions.PROGRESS_STOP_REQUEST })
        }
    }
}

function* watchGetPlickStats () {
    yield takeLatest(
        actions.FETCH_REPORT_PLICK_STATS_REQUEST,
        getPlickStats
    )
}

function* getPlickStats(bankId) {
    yield put({ type: actions.PROGRESS_START_REQUEST })
    try {
        let { data } = yield call(plickBankStats, bankId.value)
        yield put({ type: actions.FETCH_REPORT_PLICK_STATS_SUCCESS, value: data })
        // yield put(push(`/user`))
        yield put({ type: actions.PROGRESS_STOP_REQUEST })
    } catch (error) {
        if(error.response){
            yield put({ type: actions.FETCH_REPORT_PLICK_STATS_FAILURE, error: error.response })
            yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
            yield put({ type: actions.PROGRESS_STOP_REQUEST })
        }else if(error.request)
        {
            yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error })
            yield put({ type: actions.PROGRESS_STOP_REQUEST })
        }
    }
}


function* watchGetPlickStatusTypeRequest() {
    yield takeLatest(
        actions.FETCH_REPORT_PLICKSTATUS_TYPE_REQUEST,
        getPlickStatusTypeRequest
    )
}

function* getPlickStatusTypeRequest() {
    yield put({ type: actions.PROGRESS_START_REQUEST })
    try {
        let { data } = yield call(plickStatusType)
        yield put({ type: actions.FETCH_REPORT_PLICKSTATUS_TYPE_SUCCESS, value: data })
        yield put({ type: actions.PROGRESS_STOP_REQUEST })
    } catch (error) {
        if(error.response){
            yield put({ type: actions.PROGRESS_STOP_REQUEST })
            yield put({ type: actions.FETCH_REPORT_PLICKSTATUS_TYPE_FAILURE, error: error.response })
            yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
        }else if(error.request)
        {
            yield put({ type: actions.PROGRESS_STOP_REQUEST })
            yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error })
        }
    }
}


function* watchPlickstatsBankIdChange() {
    yield takeLatest(
        actions.PLICK_STATS_BANK_FIELD_CHANGE_REQUEST,
        plickstatsBankIdChange
    )
}

function* plickstatsBankIdChange(idBank) {
    if(idBank.value !== null)
        yield put({type: actions.PLICK_STATS_BANK_FIELD_CHANGE, value: idBank.value})
    else
        yield put({type: actions.PLICK_STATS_BANK_FIELD_CHANGE, value: ''})
}

function* watchGeneralReportBankIdChange() {
    yield takeLatest(
        actions.REPORT_GENERAL_BANK_FIELD_CHANGE_REQUEST,
        generalReportBankIdChange
    )
}

function* generalReportBankIdChange(idBank) {
    if(idBank.value !== null)
        yield put({type: actions.REPORT_GENERAL_BANK_FIELD_CHANGE, value: idBank.value})
    else
        yield put({type: actions.REPORT_GENERAL_BANK_FIELD_CHANGE, value: ''})
}

function* watchGeneralReportCorporateIdChange() {
    yield takeLatest(
        actions.REPORT_GENERAL_CORPORATE_FIELD_CHANGE_REQUEST,
        generalReportCorporateIdChange
    )
}

function* generalReportCorporateIdChange(corporateId) {
    if(corporateId.value !== null)
        yield put({type: actions.REPORT_GENERAL_CORPORATE_FIELD_CHANGE, value: corporateId.value})
    else
        yield put({type: actions.REPORT_GENERAL_CORPORATE_FIELD_CHANGE, value: ''})
}

function* watchGeneralReportCampaignIdChange() {
    yield takeLatest(
        actions.REPORT_GENERAL_CAMPAIGN_FIELD_CHANGE_REQUEST,
        generalReportCampaignIdChange
    )
}

function* generalReportCampaignIdChange(campaignId) {
    if(campaignId.value !== null)
        yield put({type: actions.REPORT_GENERAL_CAMPAIGN_FIELD_CHANGE, value: campaignId.value})
    else
        yield put({type: actions.REPORT_GENERAL_CAMPAIGN_FIELD_CHANGE, value: ''})
}

function* watchGeneralReportFileIdChange() {
    yield takeLatest(
        actions.REPORT_GENERAL_FILE_FIELD_CHANGE_REQUEST,
        generalReportFileIdChange
    )
}

function* generalReportFileIdChange(fileId) {
    if(fileId.value !== null)
        yield put({type: actions.REPORT_GENERAL_FILE_FIELD_CHANGE, value: fileId.value})
    else
        yield put({type: actions.REPORT_GENERAL_FILE_FIELD_CHANGE, value: ''})
}

function* watchGeneralReportDateStartChange() {
    yield takeLatest(
        actions.REPORT_GENERAL_DATESTART_FIELD_CHANGE_REQUEST,
        generalReportDateStartChange
    )
}

function* generalReportDateStartChange(dateStart) {
    if(dateStart.value !== null)
        yield put({type: actions.REPORT_GENERAL_DATESTART_FIELD_CHANGE, value: dateStart.value})
    else
        yield put({type: actions.REPORT_GENERAL_DATESTART_FIELD_CHANGE, value: ''})
}

function* watchGeneralReportDateEndChange() {
    yield takeLatest(
        actions.REPORT_GENERAL_DATEEND_FIELD_CHANGE_REQUEST,
        generalReportDateEndChange
    )
}

function* generalReportDateEndChange(dateEnd) {
    if(dateEnd.value !== null)
        yield put({type: actions.REPORT_GENERAL_DATEEND_FIELD_CHANGE, value: dateEnd.value})
    else
        yield put({type: actions.REPORT_GENERAL_DATEEND_FIELD_CHANGE, value: ''})
}

function* watchGeneralReportWhatsappChange() {
    yield takeLatest(
        actions.REPORT_GENERAL_WHATSAPP_FIELD_CHANGE_REQUEST,
        generalReportWhatsappChange
    )
}

function* generalReportWhatsappChange(whatsapp) {
    if(whatsapp.value !== null)
        yield put({type: actions.REPORT_GENERAL_WHATSAPP_FIELD_CHANGE, value: whatsapp.value})
    else
        yield put({type: actions.REPORT_GENERAL_WHATSAPP_FIELD_CHANGE, value: ''})
}

function* watchGeneralReportSmsChange() {
    yield takeLatest(
        actions.REPORT_GENERAL_SMS_FIELD_CHANGE_REQUEST,
        generalReportSmsChange
    )
}

function* generalReportSmsChange(sms) {
    if(sms.value !== null)
        yield put({type: actions.REPORT_GENERAL_SMS_FIELD_CHANGE, value: sms.value})
    else
        yield put({type: actions.REPORT_GENERAL_SMS_FIELD_CHANGE, value: ''})
}

function* watchGeneralReportEmailChange() {
    yield takeLatest(
        actions.REPORT_GENERAL_EMAIL_FIELD_CHANGE_REQUEST,
        generalReportEmailChange
    )
}

function* generalReportEmailChange(email) {
    if(email.value !== null)
        yield put({type: actions.REPORT_GENERAL_EMAIL_FIELD_CHANGE, value: email.value})
    else
        yield put({type: actions.REPORT_GENERAL_EMAIL_FIELD_CHANGE, value: ''})
}

function* watchGeneralReportOrdinaryChange() {
    yield takeLatest(
        actions.REPORT_GENERAL_ORDINARY_FIELD_CHANGE_REQUEST,
        generalReportOrdinaryChange
    )
}

function* generalReportOrdinaryChange(ordinary) {
    if(ordinary.value !== null)
        yield put({type: actions.REPORT_GENERAL_ORDINARY_FIELD_CHANGE, value: ordinary.value})
    else
        yield put({type: actions.REPORT_GENERAL_ORDINARY_FIELD_CHANGE, value: ''})
}

function* watchGeneralReportFutureDateChange() {
    yield takeLatest(
        actions.REPORT_GENERAL_FUTUREDATE_FIELD_CHANGE_REQUEST,
        generalReportFutureDateChange
    )
}

function* generalReportFutureDateChange(futureDate) {
    if(futureDate.value !== null)
        yield put({type: actions.REPORT_GENERAL_FUTUREDATE_FIELD_CHANGE, value: futureDate.value})
    else
        yield put({type: actions.REPORT_GENERAL_FUTUREDATE_FIELD_CHANGE, value: ''})
}

function* watchGeneralReportStatusChange() {
    yield takeLatest(
        actions.REPORT_GENERAL_STATUS_FIELD_CHANGE_REQUEST,
        generalReportStatusChange
    )
}

function* generalReportStatusChange(status) {
    if(status.value !== null)
        yield put({type: actions.REPORT_GENERAL_STATUS_FIELD_CHANGE, value: status.value})
    else
        yield put({type: actions.REPORT_GENERAL_STATUS_FIELD_CHANGE, value: ''})
}

function* watchFileStatsBankChange() {
    yield takeLatest(
        actions.REPORT_CORPORATE_FILE_STATS_BANK_FIELD_CHANGE_REQUEST,
        fileStatsBankChange
    )
}

function* fileStatsBankChange(bankId) {
    if(bankId.value !== null)
        yield put({type: actions.REPORT_CORPORATE_FILE_STATS_BANK_FIELD_CHANGE, value: bankId.value})
    else
        yield put({type: actions.REPORT_CORPORATE_FILE_STATS_BANK_FIELD_CHANGE, value: ''})
}

function* watchFileStatsCorporateChange() {
    yield takeLatest(
        actions.REPORT_CORPORATE_FILE_STATS_CORPORATE_FIELD_CHANGE_REQUEST,
        fileStatsCorporateChange
    )
}

function* fileStatsCorporateChange(corporate) {
    if(corporate.value !== null)
        yield put({type: actions.REPORT_CORPORATE_FILE_STATS_CORPORATE_FIELD_CHANGE, value: corporate.value})
    else
        yield put({type: actions.REPORT_CORPORATE_FILE_STATS_CORPORATE_FIELD_CHANGE, value: ''})
}

function* watchFetchCorporate() {
    yield takeLatest(
        actions.FETCH_REPORT_CORPORATE_REQUEST,
        fetchCorporate
    )
}

function* fetchCorporate(bankIds) {
    yield put({type: actions.CLEAN_ERROR})
    yield put({ type: actions.PROGRESS_START_REQUEST })
    try {
        let { data } = yield call(getCorporatesByBankId, bankIds.value)
        yield put({ type: actions.FETCH_REPORT_CORPORATE_SUCCESS, value: data })
        // yield put(push(`/user`))
        yield put({ type: actions.PROGRESS_STOP_REQUEST })
    } catch (error) {
        if(error.response){
            yield put({ type: actions.FETCH_REPORT_CORPORATE_FAILURE, error: error.response })
            yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
            yield put({ type: actions.PROGRESS_STOP_REQUEST })
        }else if(error.request)
        {
            yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error })
            yield put({ type: actions.PROGRESS_STOP_REQUEST })
        }
    }
}

function* watchFetchCampaign() {
    yield takeLatest(
        actions.FETCH_REPORT_CAMPAIGN_REQUEST,
        fetchCampaign
    )
}

function* fetchCampaign(corporateIds) {
    yield put({type: actions.CLEAN_ERROR})
    yield put({ type: actions.PROGRESS_START_REQUEST })
    try {
        let { data } = yield call(getCampaignsByCorporate, corporateIds.value)
        yield put({ type: actions.FETCH_REPORT_CAMPAIGN_SUCCESS, value: data })
        // yield put(push(`/user`))
        yield put({ type: actions.PROGRESS_STOP_REQUEST })
    } catch (error) {
        if(error.response){
            yield put({ type: actions.FETCH_REPORT_CAMPAIGN_FAILURE, error: error.response })
            yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
            yield put({ type: actions.PROGRESS_STOP_REQUEST })
        }else if(error.request)
        {
            yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error })
            yield put({ type: actions.PROGRESS_STOP_REQUEST })
        }
    }
}

function* watchFetchFiles() {
    yield takeLatest(
        actions.FETCH_REPORT_FILES_REQUEST,
        fetchFiles
    )
}

function* fetchFiles(campaignIds) {
    yield put({type: actions.CLEAN_ERROR})
    yield put({ type: actions.PROGRESS_START_REQUEST })
    try {
        let { data } = yield call(getFilesByCampaign, campaignIds.value)
        yield put({ type: actions.FETCH_REPORT_FILES_SUCCESS, value: data })
        // yield put(push(`/user`))
        yield put({ type: actions.PROGRESS_STOP_REQUEST })
    } catch (error) {
        if(error.response){
            yield put({ type: actions.FETCH_REPORT_FILES_FAILURE, error: error.response })
            yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
            yield put({ type: actions.PROGRESS_STOP_REQUEST })
        }else if(error.request)
        {
            yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error })
            yield put({ type: actions.PROGRESS_STOP_REQUEST })
        }
    }
}





